import { render } from "./commonSelectInput.vue?vue&type=template&id=97f1b80a&scoped=true"
import script from "./commonSelectInput.vue?vue&type=script&lang=js"
export * from "./commonSelectInput.vue?vue&type=script&lang=js"

import "./commonSelectInput.vue?vue&type=style&index=0&id=97f1b80a&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f1b80a"]])

export default __exports__